import React from 'react';

// Selectable cards with radio-group semantics. Arrow keys move focus between
// cards; Enter or Space selects. Selection stays explicit because selecting
// a card can trigger a load (service types, service type detail).
const FOCUS_KEYS = {
  ArrowRight: 1,
  ArrowDown: 1,
  ArrowLeft: -1,
  ArrowUp: -1,
};

export const ChoiceGroup = ({ label, className, children }) => {
  const onKeyDown = (event) => {
    const step = FOCUS_KEYS[event.key];
    if (!step) return;
    const radios = Array.from(event.currentTarget.querySelectorAll('[role="radio"]'));
    const index = radios.indexOf(document.activeElement);
    if (index === -1 || radios.length === 0) return;
    event.preventDefault();
    radios[(index + step + radios.length) % radios.length].focus();
  };

  return (
    <div role="radiogroup" aria-label={label} className={className} onKeyDown={onKeyDown}>
      {children}
    </div>
  );
};

export const ChoiceCard = ({ checked, onSelect, className, style, children }) => {
  const onKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onSelect(event);
    }
  };

  return (
    <div
      role="radio"
      aria-checked={checked ? 'true' : 'false'}
      tabIndex={0}
      className={`bk-choice${checked ? ' is-checked' : ''}${className ? ` ${className}` : ''}`}
      style={style}
      onClick={onSelect}
      onKeyDown={onKeyDown}
    >
      {children}
    </div>
  );
};
